"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchParamsString = exports.useQueryParams = void 0;
const react_1 = require("react");
const react_router_1 = require("react-router");
const table_columns_1 = require("../../common/table-columns");
const useQueryParams = () => {
    const { search } = (0, react_router_1.useLocation)();
    const searchParams = (0, react_1.useMemo)(() => {
        const params = new URLSearchParams(search);
        const entries = Object.fromEntries(params.entries());
        const { attributeName, value } = entries;
        if (attributeName) {
            const { label: parsedAttributeName, dataMeta: { isMeasure } } = (0, table_columns_1.parseColumnId)(decodeURIComponent(attributeName));
            entries.attributeName = parsedAttributeName;
            entries.isMeasure = isMeasure;
        }
        if (value) {
            entries.value = decodeURIComponent(value);
        }
        return entries;
    }, [search]);
    return searchParams;
};
exports.useQueryParams = useQueryParams;
const useSearchParamsString = () => {
    const getSearchParamsString = (0, react_1.useCallback)((params) => {
        const encodedParams = Object.assign({}, params);
        const { attributeName, value, isMeasure = false } = encodedParams;
        if (attributeName) {
            const attributeWithTypePrefix = (0, table_columns_1.createColumnId)(encodeURIComponent(attributeName), { isMeasure, isAIEnriched: !isMeasure });
            encodedParams.attributeName = attributeWithTypePrefix;
        }
        if (value) {
            encodedParams.value = encodeURIComponent(encodedParams.value);
        }
        const queryParams = new URLSearchParams(encodedParams).toString();
        return `?${queryParams}`;
    }, []);
    return { getSearchParamsString };
};
exports.useSearchParamsString = useSearchParamsString;
